import * as React from "react";
import "./BookPrice.scss";

// markup
export default function BookPrice(props) {
  return (
    <a href="#book-buy" className="book-price">
      <span className="book-price__title">Read Now For</span>
      <span className="book-price__cost">{props.price ? props.price : 'Free!'}</span>
    </a>
  );
};
